import * as PropTypes from 'prop-types'

export const SupplierResultShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  states: PropTypes.array.isRequired,
  designation_tags: PropTypes.array.isRequired,
  contact_us_link: PropTypes.string
})
